"use strict";

var fixedTableHelper = function () {
  var $rcBody = null;
  var $rcInputs = null;
  var $commentModal = null;

  function createCommentsWindow() {
    var $commentModalWrap = $('#FixTblCommentModal');

    if ($commentModalWrap.length) {
      $commentModalWrap.remove();
    }

    $('body').append("<div id=\"FixTblCommentModal\" class=\"modal-content-wrap\">\n                                <p id=\"FixTblCommentDesc\"></p>\n                                <textarea id=\"FixTblCommentInp\" class=\"inp -wide\" placeholder=\"\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u043A \u043E\u0442\u0432\u0435\u0442\u0443\" rows=\"6\"></textarea>\n                          </div>");
  }

  function cacheNodes() {
    $rcBody = $('.rest-columns > .tbody');
    $rcInputs = $('.rest-columns .inp');
    $commentModal = $('#FixTblCommentModal');
  }

  function initClearCommentBttns() {
    $rcInputs.each(function () {
      var $this = $(this);

      if ($this.val().trim().length && $(window).width() < 1100) {
        $this.next('.inp-clear').css('visibility', 'visible');
      } else {
        $this.next('.inp-clear').css('visibility', 'hidden');
      }
    });
  }
  /* Make as method and trigger after paging */


  function setTableInitState() {
    $rcBody.each(function () {
      var $this = $(this);

      if ($this.get(0).scrollWidth > $this.innerWidth()) {
        $this.closest('.rest-columns').addClass('-scrolled');
      }
    });
  }

  function unbindHandlers() {
    $rcBody.off('scroll');
  }

  function bindHandlers() {
    $rcBody.scroll(function () {
      var $this = $(this),
          top = $this.scrollTop(),
          left = $this.scrollLeft() + 20,
          width = $this.outerWidth(),
          scrollWidth = $this[0].scrollWidth;
      var $table = $this.closest('.fixed-tbl-wrapper'),
          $fc = $table.find('.fix-column'),
          $fcBody = $table.find('.fix-column > .tbody'),
          $rc = $table.find('.rest-columns'),
          // $rcBody = $table.find('.rest-columns > .tbody'),
      $rcHead = $table.find('.rest-columns > .thead');

      if (scrollWidth - width <= left) {
        $rc.removeClass('-scrolled');
      } else {
        $rc.addClass('-scrolled');
      }

      if (left > 0) {
        $fc.addClass('-overflowed');
      } else {
        $fc.removeClass('-overflowed');
      }

      $fcBody.scrollTop(top);
      $rcHead.scrollLeft(left);
    });
    $(document).on('click', '.inp-clear', function () {
      var $this = $(this);
      $this.siblings('.inp').val('');
      $this.css('visibility', 'hidden');
    });
    $(document).on('click', '.rest-columns .inp', function () {
      var $tblInput = $(this);
      var $tblInputClear = $tblInput.next('.inp-clear');
      var $commentDesc = $('#FixTblCommentDesc');
      var $commentInp = $('#FixTblCommentInp');

      if ($(window).width() < 1100) {
        $commentModal.showAsModal({
          title: 'Комментарий к ответу',
          isVertical: true,
          buttons: [{
            title: 'Сохранить',
            big: true,
            primary: true,
            wide: true,
            onClick: function onClick() {
              // save content of text (to server ?)
              var comment = $commentInp.val().trim();
              $tblInput.val(comment);

              if (comment.length) {
                $tblInputClear.css('visibility', 'visible');
              } else {
                $tblInputClear.css('visibility', 'hidden');
              }
            }
          }, {
            title: 'Очистить',
            big: true,
            wide: true,
            onClick: function onClick() {
              // clear content of text (to server ?)
              $commentInp.val('');
              $tblInput.val('');
              $tblInputClear.css('visibility', 'hidden');
            }
          }],
          afterOpen: function afterOpen() {
            var comment = $tblInput.val();
            $('.modal-footer').addClass('-space-between');
            $commentDesc.text("\u0414\u043B\u044F \u043E\u0442\u0432\u0435\u0442\u0430 \"".concat($tblInput.data('answer-text'), "\""));
            $commentInp.val(comment);
          }
        });
      }
    });
    $(window).on('resize', initClearCommentBttns);
  }

  function init() {
    createCommentsWindow();
    cacheNodes();
    unbindHandlers();
    bindHandlers();
    initClearCommentBttns();
    setTableInitState(); // trigger from outside, maybe with param
  }

  return {
    init: init
  };
}();